<template>
  <DropdownListSearch
    :buttonText="countryListText"
    fieldName="A country"
    :isLoading="isLoading"
    :options="options"
    :selectedOptions="selectedOptions"
    shouldShowSearch
    @input="handleInput"
  />
</template>

<script>
import { Types } from '@jumpcloud/ui-components';
import { mapActions, mapGetters } from 'vuex';
import pluralize from 'pluralize';

import DropdownListSearch from 'client/Security/AuthNPoliciesAsidePanel/ConditionsSection/DropdownListSearch.vue';

const { ListboxItem } = Types;

export default {
  name: 'LocationListSearch',

  components: {
    DropdownListSearch,
  },

  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      isLoading: false,
    };
  },

  computed: {
    ...mapGetters('GeolocationCollection', {
      getLocationCollection: 'getCollection',
    }),

    countryListText() {
      const count = this.value.length;

      return count === 0
        ? 'Select Value'
        : `${count} ${pluralize('Country', count)} selected`;
    },

    locationCodeMap() {
      return this.options.reduce((acc, option) => {
        acc[option.value] = option.name;
        return acc;
      }, {});
    },

    options() {
      return this.getLocationCollection.map(item => new ListboxItem({
        name: item.name,
        value: item.code,
      }));
    },

    selectedOptions() {
      return this.value.map(code => new ListboxItem({
        name: this.locationCodeMap[code],
        value: code,
      }));
    },
  },

  mounted() {
    this.isLoading = true;
    this.fetchCollection().finally(() => { this.isLoading = false; });
  },

  methods: {
    ...mapActions('GeolocationCollection', ['fetchCollection']),

    handleInput(filters) {
      // TODO: move filter.map to ConditionLocations.toApi()
      this.$emit('input', filters.map(({ value }) => value));
    },
  },
};
</script>
